import React from 'react'
import isepakLogoDark from '@assets/svg/logo-speakduo-dark.svg'
import pengguinLogo from '@assets/svg/pengguin-logo.svg'
import { LoginForm } from '@features/auth/components'
import { useTheme } from '@features/theme/theme.hooks'
import { Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Button, Link, Paper, Typography } from '@common/components'
import { MAIN_ROUTE } from '@common/constants/routes'
import { CenterContainer } from '@common/containers'
import { ArrowOutwardIcon } from '@common/icons'
import { RouterLink } from '@lib/router'

const Login: React.FC = () => {
  const { t } = useTranslation('login-page')
  const { isDark } = useTheme()
  return (
    <>
      <Button
        component={RouterLink}
        to={MAIN_ROUTE}
        color='neutral'
        variant='text'
        sx={{
          fontWeight: 600,
          color: 'GrayText',
          position: 'absolute',
          top: 5,
          right: 50,
          ':hover': {
            color: (theme: Theme) => (theme.palette.mode === 'dark' ? 'white' : 'black'),
          },
        }}
      >
        Explore Events
        <ArrowOutwardIcon sx={{ fontSize: '14px' }} />
      </Button>
      <CenterContainer>
        <Paper sx={{ py: { xs: 2, md: 5 }, borderRadius: '20px', maxWidth: '90%' }}>
          <Link component={RouterLink} to={MAIN_ROUTE}>
            <img
              src={isDark ? isepakLogoDark : pengguinLogo}
              alt={'pegguin'}
              style={{
                display: 'block',
                width: '190px',
                margin: '0 auto',
                marginBottom: '22px',
              }}
            />
          </Link>
          <Typography align='center' sx={{ mb: 0.5, fontSize: { xs: '16px', md: '20px' } }}>
            {t('title', 'Sign in')}
          </Typography>
          <LoginForm />
        </Paper>
      </CenterContainer>
    </>
  )
}

export default Login
